"use strict";

(function () {

    $.widget('khis.dropDownCombo', {
        options: {
            optionsList:[]
        },
        _create: function () {
            this.element.hide();

            this.container = $('<div role="container"></div>');
            this.container.attr('class', this.element.attr("class"));
            this.container.attr('style', 'height: 30px; line-height: 30px; text-transform: uppercase; font-size: 15px; '+(this.element.attr("style")?this.element.attr("style"):''));
            this.container.show();

            this.displayCt = $('<span role="display" style="cursor: pointer; color: #595959; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 250px;" class="float_left"></span>');
            this.displayCt.html(this.element.find('option:selected').html());
            this.displayArrow = $('<span role="displayArrow" class="float_left ui-icon ui-icon-triangle-1-s" style="cursor: pointer;"></span>');

            if(this.container.height() && parseInt(this.container.height()) != NaN){
                this.displayArrow.css('margin-top', ((this.container.height()-16)/2)+'px');
            }

            this.displayCt.data('dcbTarget', this);
            this.displayArrow.data('dcbTarget', this);

            this.displayCt.appendTo(this.container);
            this.displayArrow.appendTo(this.container);
            $('<div class="spacer"></div>').appendTo(this.container);

            this.element.after(this.container);
        },
        _init: function () {
            // Listen to click
            this._on({
                'change': function (event) {
                    this.displayCt.html(this.element.find('option:selected').html());
                }
            });

            this.displayCt.click(this.showOptions);
            this.displayArrow.click(this.showOptions);

            this.refresh();
        },
        _destroy: function () {
            this.container.remove();
            this.element.show();
        },
        refresh: function(){
            this.options.optionsList = [];

            // Update option list
            var options = this.element.find('option');

            for(var i = 0; i < options.length; i++){
                this.options.optionsList.push({
                    label: $(options[i]).html(),
                    tooltip: $(options[i]).html(),
                    data: $(options[i]).val(),
                    params: {
                        dcbTarget: this
                    }
                });
            }

            // Update display
            this.displayCt.html(this.element.find('option:selected').html());
        },
        showOptions: function(){
            var t = $(this).data('dcbTarget');
            if(t && t.options.optionsList.length > 0){
                Popups.Multichoice.show(t.displayArrow, t.options.optionsList, {align:'right'}, onActionClick);
            }
        },
        getOptions: function() {
            return this.options.optionsList;
        },
        setOption: function(option) {
            this.element.val(option);
            this.refresh();
            this.element.trigger('change');
        }
    });

    function onActionClick(action) {
        action.params.dcbTarget.setOption(action.data);
    }
})();